import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#18181B] text-gray-400 py-16 px-4 text-center border-t border-white/5 relative" data-id="element-80">
      {/* Top gradient border */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent" data-id="element-81"></div>

      <div className="max-w-4xl mx-auto" data-id="element-82">
        <p className="mb-4 text-white font-medium text-lg tracking-wide" data-id="element-83">
          © 2026 Manual de Biohacking + 800 Recetas
        </p>
        <p className="text-sm text-gray-500 mb-8" data-id="element-84">
          Todos los derechos reservados
        </p>
        <div className="text-xs text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-85">
          <p data-id="element-86">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}